import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { partnerSettingsService } from "@/services/partner-settings-service";
import { getPartnerRangeParams } from "@/components/pages/guesteria-partners/utils/partnerAnalyticsPeriod";
import type { PartnerRevenueDateRange } from "@/components/pages/guesteria-partners/utils/partnerRevenuePeriodPresets";
import type { PartnerAttributionReport } from "@/types/partner-attribution";

/**
 * "Activities by room" report (task 0041, contract 2026-09-30) — hotel
 * staff and tenant admin share this same hotel-scoped endpoint, so one hook
 * covers both the hotel `/guesteria-partners/:id` page and the tenant
 * `/guesteria-partners-revenue/:hotelId` page.
 */
export const usePartnerAttribution = (
  hotelId: string | undefined,
  range: PartnerRevenueDateRange,
  enabled = true,
) => {
  const params = useMemo(() => getPartnerRangeParams(range), [range]);

  return useQuery<PartnerAttributionReport>({
    queryKey: [
      "partnerAttribution",
      hotelId || "",
      params.from,
      params.to,
    ] as const,
    enabled: Boolean(hotelId) && enabled,
    queryFn: () =>
      partnerSettingsService.getPartnerAttribution(hotelId!, params),
    staleTime: 60 * 1000,
  });
};
